import IllustrationHero from '@/components/heros/IllustrationHero';
import { ModuleIllustrationHeroFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { getSingle } from '@/lib/typescript-helpers';
import { FC, ReactNode } from 'react';
import Image from '@/components/Image';

interface IllustrationHeroModuleProps {
  props: CraftModuleFragment<ModuleIllustrationHeroFragment>;
}

const IllustrationHeroModule: FC<IllustrationHeroModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  let image: ReactNode = null;

  const asset = getSingle(props.illustration);

  if (asset && asset.url) {
    image = <Image src={asset.url} width={asset.width ?? 0} height={asset.height ?? 0} alt="" />;
  }

  return (
    <IllustrationHero
      eyebrowText={props.eyebrowText ?? undefined}
      heading={props.heading ?? ''}
      content={parseHtml(props.text)}
      image={image}
      ctaText={props.ctaText ?? undefined}
    />
  );
};

export default IllustrationHeroModule;
